import * as React from 'react';

/**
 * Two plugs joined on a diagonal, cables trailing out, a tick either side of
 * the join: an integration that is connected. Used for Analytics Integrations
 * (GA4 / Segment push) so it no longer shares a cloud silhouette with the
 * Migrate to FileSpin entry directly above it.
 */
function PlugsConnected(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path
        d="M13.88 13.88l4.24 4.24-6.36 6.36-4.24-4.24 6.36-6.36zM13.88 13.88l4.24 4.24 6.36-6.36-4.24-4.24-6.36 6.36z"
        stroke="currentColor"
       
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.64 22.36L5 27M22.36 9.64L27 5M12.5 12.5l-2-2M19.5 19.5l2 2"
        stroke="currentColor"
       
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PlugsConnected;
